import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

export const useInvalidateQuery = (queryKey?: string) => {
  const queryClient = useQueryClient();

  return useCallback(() => {
    if (queryKey) {
      return queryClient.invalidateQueries({
        predicate(query) {
          return query.queryKey.includes(queryKey);
        },
      });
    }
    return Promise.resolve();
  }, [queryClient, queryKey]);
};
